import {
  aromaContextualIcon,
  AromaContextualIconVariantProps,
} from "@zenchef/styled-system/recipes";
import Icon from "../Icon/Icon";
import { IconName } from "@zenchef/icomoon";
import { Box, BoxProps } from "@zenchef/styled-system/jsx";
import { cx } from "@zenchef/styled-system/css";

// Define allowed variants
// We need this because we want to prevent BOLD and AI from being used together
type AllowedVariants =
  | { colorTheme?: "ai"; hierarchy: "subtlest" | "subtle" | "bolder" }
  | {
      colorTheme?: Exclude<AromaContextualIconVariantProps["colorTheme"], "ai">;
      hierarchy: AromaContextualIconVariantProps["hierarchy"];
    };

export type ContextualIconProps = BoxProps &
  Omit<AromaContextualIconVariantProps, "colorTheme" | "hierarchy"> &
  AllowedVariants & {
    name?: IconName;
  };

const ContextualIcon = ({
  name,
  className,
  children,
  ...propsWithVariants
}: ContextualIconProps) => {
  const [variantProps, props] =
    aromaContextualIcon.splitVariantProps(propsWithVariants);
  const classes = aromaContextualIcon(variantProps);

  return (
    <Box className={cx(classes.root, className)} {...props}>
      <svg viewBox="0 0 40 40" className={classes.svg}>
        <path d="M39.5 20C39.5 28.0279 38.4984 32.8288 35.6636 35.6636C32.8288 38.4984 28.0279 39.5 20 39.5C11.9721 39.5 7.17125 38.4984 4.33642 35.6636C1.50159 32.8288 0.5 28.0279 0.5 20C0.5 11.9721 1.50159 7.17125 4.33642 4.33642C7.17125 1.50159 11.9721 0.5 20 0.5C28.0279 0.5 32.8288 1.50159 35.6636 4.33642C38.4984 7.17125 39.5 11.9721 39.5 20Z"></path>

        <defs>
          <clipPath
            id="clipShape"
            transform="scale(0.025, 0.025)"
            clipPathUnits="objectBoundingBox"
          >
            <path d="M39.5 20C39.5 28.0279 38.4984 32.8288 35.6636 35.6636C32.8288 38.4984 28.0279 39.5 20 39.5C11.9721 39.5 7.17125 38.4984 4.33642 35.6636C1.50159 32.8288 0.5 28.0279 0.5 20C0.5 11.9721 1.50159 7.17125 4.33642 4.33642C7.17125 1.50159 11.9721 0.5 20 0.5C28.0279 0.5 32.8288 1.50159 35.6636 4.33642C38.4984 7.17125 39.5 11.9721 39.5 20Z"></path>
          </clipPath>
        </defs>
      </svg>
      <Icon name={name} />
      {children}
    </Box>
  );
};

export default ContextualIcon;
